export default __webpack_public_path__ + "static/media/g2022-15.727d3b24.jpeg";